export default __webpack_public_path__ + "static/media/email_share.d35c41cb.svg";